import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageTitleTextButton from "../modules/ImageTitleTextButton";
import TitleTextButton from "../modules/TitleTextButton";
import QuoteModule from "../modules/QuoteModule";
import NeubauProjekteImageVideo from "../components/NeubauProjekteImageVideo";
import ImageBeforeAfter from "./ImageBeforeAfter";

const SanierungenDetailTabs = ({ allData }) => {
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        if (allData?.length > 0) {
            setActiveTab(allData[0]?.Tab_Titel);
        }

        console.log('here data >>>>>>>>>>>>>>', allData)
    }, [allData]);

    useEffect(() => {
        const equalHeight = () => {
            // 👉 H4 elements
            const headings = document.querySelectorAll(
                ".tab-content .col-inner h4"
            );

            let maxH4 = 0;
            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });
            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });
        };



        // run on load
        setTimeout(equalHeight, 300);
        // run on resize
        window.addEventListener("resize", equalHeight);
        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    useEffect(() => {
        console.log("all data", allData)
    }, [])

    const currentTabData = allData?.find(
        (item) => item.Tab_Titel === activeTab
    );

    return (
        <div className='tab-container mt-4'>
            <div className='container'>
                <ul className="nav nav-tabs">
                    {allData?.map((tab, index) => (

                        <li className="nav-item" key={index}>

                            <button
                                className={`nav-link ${activeTab === tab?.Tab_Titel ? "active" : ""
                                    }`}
                                onClick={() => setActiveTab(tab?.Tab_Titel)}
                            >
                                {tab?.Tab_Titel}
                            </button>

                        </li>

                    ))}
                </ul>
            </div>
            <div className="sec-bg-grey mt-4">
                <div className='container'>
                    <div className="tab-content">
                        {currentTabData?.sanierungen_registerkarten_daten?.Modul?.map((module, index) => (
                            <div key={index}>
                                {module.__component === "modules.short-titel-titel-text-button" &&
                                    <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                        <div className='container'>
                                            <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                        </div>
                                    </section>
                                }
                                {module.__component === "modules.carousel-bild-re-text" &&
                                    <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="blue" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                                }
                                {module.__component === "modules.quote" &&
                                    <section className={`pt-pb-10 sec-blue-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>
                                        <div className='container'>
                                            <QuoteModule data={module?.Quote} titleColor="blue" />
                                        </div>
                                    </section>
                                }
                                {module.__component === "modules.benefits" &&
                                    <section className='pt-pb-10 sec-bg-grey sec-pink-color'>
                                        <div className='container'>
                                            <div className='row default-grid-gap job-card-row tabs-content'>
                                                {module?.Benefits_Data?.map((item, index) => (
                                                    <div key={index} className='col-6 col-md-4 col-lg-3 col-item mt-4'>
                                                        <div className="col-inner position-relative">
                                                            <img src={`https://backend.bgzurlinden.ch${item.Icon?.url}`} alt={item?.Titel} className="item-icon" />
                                                            <h4 lang="de" className='text-darkgrey fw-550 fs_24'>{item?.Titel}</h4>
                                                            <p lang="de">{item?.Text}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </section>
                                }
                                {module.__component === "modules.vorher-nachher-bild-und-text" &&
                                    <ImageBeforeAfter module={module} shortTitle={module?.Kurztitel} beforeImage={module?.Vorher_Bild} afterImage={module?.Nachbild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="blue" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                                }
                            </div>
                        ))}
                    </div>
                    {/* <div className="tab-content">
                        {activeTab === "Tab_1" && (
                            <div className="tab-pane active">
                                <div className='row'>
                                    <div className='col-lg-6 content-col mb-3 mb-lg-0 align-self-center'>
                                        <h2 className='text-black mb-3'>Aenean sollicitudin</h2>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col'>
                                        <NeubauProjekteImageVideo />
                                    </div>
                                </div>
                                <div className='row flex-lg-row-reverse mt-lg-4'>
                                    <div className='col-lg-6 content-col mt-4 align-self-center'>
                                        <h2 className='text-black mb-3'>Duis sed odio</h2>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col mt-4'>
                                        <img src='images/image-before-after-construction.png' className='w-100' alt='#' />
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab === "Tab_2" && (
                            <div className="tab-pane active">
                                <div className='row'>
                                    <div className='col-lg-6 content-col mb-3 mb-lg-0 align-self-center'>
                                        <h2 className='text-black mb-3'>Aenean sollicitudin</h2>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col'>
                                        <NeubauProjekteImageVideo />
                                    </div>
                                </div>
                                <div className='row flex-lg-row-reverse mt-lg-4'>
                                    <div className='col-lg-6 content-col mt-4 align-self-center'>
                                        <h2 className='text-black mb-3'>Duis sed odio</h2>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col mt-4'>
                                        <img src='images/image-before-after-construction.png' className='w-100' alt='#' />
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab === "Tab_3" && (
                            <div className="tab-pane active">
                                <div className='row'>
                                    <div className='col-lg-6 content-col mb-3 mb-lg-0 align-self-center'>
                                        <h2 className='text-black mb-3'>Aenean sollicitudin</h2>
                                        <p>Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col'>
                                        <NeubauProjekteImageVideo />
                                    </div>
                                </div>
                                <div className='row flex-lg-row-reverse mt-lg-4'>
                                    <div className='col-lg-6 content-col mt-4 align-self-center'>
                                        <h2 className='text-black mb-3'>Duis sed odio</h2>
                                        <p>Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit. Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi et amet accumsan ipsum velit. Nam nec tellus a odio tincidunt auctor a ornare odio. Sed non mauris vitae erat consequat auctor eu in elit. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo.</p>
                                        <p>Nibh vel velit auctor aliquet. Aenean sollicitudin, lorem quis bibendum auctor.</p>
                                    </div>
                                    <div className='col-lg-6 image-col mt-4'>
                                        <img src='images/image-before-after-construction.png' className='w-100' alt='#' />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default SanierungenDetailTabs